import React from 'react'
import { FaEnvelope, FaPhone } from 'react-icons/fa'
import './ContactInfo.css'

const ContactInfo = () => {
  return (
    <div className='contact-page'>
      <h3>Contact Us</h3>

      <p className='contact-intro'>
        For project inquiries, custom millwork, and finish carpentry questions,
        please reach out by phone or email.
      </p>

      <div className='contact-details'>
        <p className='contact-item'>
          <FaEnvelope className='icon' />
          <a href='mailto:CambiumRocks@gmail.com'>
            CambiumRocks@gmail.com
          </a>
        </p>

        <p className='contact-item'>
          <FaPhone className='icon' />
          <a href='tel:19169967550'>(916) 996-7550</a>
        </p>

        <p className='license-line'>
          <strong>License:</strong> CA License #1152316
        </p>
      </div>
    </div>
  )
}

export default ContactInfo